import { ExIcon, ExMenu, ExMenuItem, MenuItemVariant } from '@boomi/exosphere';
import { translations } from '../translations/translations';
import { useApp } from './AppProvider';
import { boomiNavigationMenuLinks } from './BoomiNavigationMenuLinks';

const BoomiNavigationMenuMobile = () => {
    const { language } = useApp();
    const { platform, products, labs } = boomiNavigationMenuLinks(language);

    return (
        <ExMenu className="boomi-navigation-menu">
            <hr className="menu-separator" />
            <span className="menu-heading">{translations[language].BOOMI_HEADER_platform}</span>
            {platform.map((item) => (
                <a
                    key={item.title}
                    className="menu-item-link"
                    href={item.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    tabIndex={-1}
                >
                    <ExMenuItem className="menu-item" variant={MenuItemVariant.NAVIGATION}>
                        <ExIcon className="menu-item-icon" icon={item.icon} />
                        {item.title}
                    </ExMenuItem>
                </a>
            ))}
            <hr className="menu-separator" />
            <span className="menu-heading">{translations[language].BOOMI_HEADER_products}</span>
            {products.map((item) => (
                <a
                    key={item.title}
                    className="menu-item-link"
                    href={item.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    tabIndex={-1}
                >
                    <ExMenuItem className="menu-item" variant={MenuItemVariant.NAVIGATION}>
                        <ExIcon className="menu-item-icon" icon={item.icon} />
                        {item.title}
                    </ExMenuItem>
                </a>
            ))}
            <hr className="menu-separator" />
            <span className="menu-heading">
                <ExIcon className="menu-item-icon" icon="Lab" />
                {translations[language].BOOMI_HEADER_labs}
            </span>
            {labs.map((item) => (
                <a
                    key={item.title}
                    className="menu-item-link"
                    href={item.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    tabIndex={-1}
                >
                    <ExMenuItem className="menu-item" variant={MenuItemVariant.NAVIGATION}>
                        {item.title}
                    </ExMenuItem>
                </a>
            ))}
        </ExMenu>
    );
};

export default BoomiNavigationMenuMobile;
